/*
 * Copyright (c) 2022, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loginBgLogin: {
      backgroundColor: '#F7F8FB',
      height: 'calc(100vh - 48px)',
      overflowY: 'auto',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    choreoLoginLogo: {
      paddingTop: theme.spacing(9.125),
      display: 'flex',
      justifyContent: 'center',
    },
    choreoSignInText: {
      paddingLeft: theme.spacing(1),
      paddingTop: theme.spacing(6.25),
      paddingBottom: theme.spacing(1.25),
      textAlign: 'center',
    },
    rectangle: {
      paddingTop: theme.spacing(2.75),
      paddingBottom: theme.spacing(2.75),
      boxSizing: 'border-box',
      height: theme.spacing(80),
      width: theme.spacing(50),
      border: '1px solid #E6E7EC',
      borderRadius: 8,
      boxShadow: '0 5px 30px 0 rgba(102,103,133,0.17)',
    },
    choreMoreDetails: {
      paddigTop: theme.spacing(6.5),
      display: 'flex',
      justifyContent: 'center',
      cursor: 'pointer',
    },
    choreoMoreDetailsLink: {
      display: 'flex',
      justifyContent: 'center',
      cursor: 'pointer',
    },
    choreoMoreDetailsContainer: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(8.625),
    },
    google: {
      color: 'rgba(0,0,0,0.54)',
    },
    github: {
      color: 'rgba(0,0,0,0.8)',
    },
    microsoft: {
      color: 'rgba(0,0,0,0.8)',
    },
    loginBtn: {
      fontFamily: 'Roboto',
      paddingLeft: 8,
      paddingRight: 8,
      height: 40,
      width: 215,
      textTransform: 'none',
      fontSize: 14,
      fontWeight: 500,
      lineHeight: 1.5,
      borderRadius: 2,
      letterSpacing: 0.22,
      boxShadow: '0 0 1px 0 rgba(0,0,0,0.12), 0 1px 1px 0 rgba(0,0,0,0.24)',
      marginTop: theme.spacing(1.5),
      backgroundColor: theme.palette.common.white,
      whiteSpace: 'nowrap',
      '&:hover, &:focus, &:active': {
        backgroundColor: '#EEEEEE',
        boxShadow: '0 0 2px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24)',
      },
    },
    btnIcon: {
      marginRight: theme.spacing(3),
      height: theme.spacing(2.25),
      width: theme.spacing(2.25),
    },
    loginMsg: {
      color: theme.palette.primary.main,
      fontWeight: 450,
      fontSize: 17,
      display: 'inline',
    },
    msgText: {
      paddingTop: theme.spacing(8),
      display: 'block',
    },
    inviteMsg: {
      color: '#40404B',
      fontWeight: 500,
      marginTop: theme.spacing(1),
      textAlign: 'center',
      paddingLeft: '20px',
      paddingRight: '20px',
    },
    orgName: {
      color: theme.palette.primary.main,
      fontWeight: 500,
      marginTop: theme.spacing(1),
      textAlign: 'center',
    },
    identityProvider: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: theme.spacing(5),
    },
    identityProviderImage: {
      width: '129px',
      height: '32px',
      marginTop: theme.spacing(0.5),
    },
  })
);

export default useStyles;
